import {IsoDate} from "../../pseudo-types/DateTypes";
import {Comparator} from "../../types/GenericTypes";
import {ascending, descending} from "../../js/util/UtilFunctions";
import {Exchange} from "../../instruments/exchange/Exchange";
import {DividendType} from "./DividendType";

export type SecurityDividendsRecord = ReadonlyArray<SecurityDividends>;

export interface SecurityDividends {
    readonly code: string;
    readonly exchange: Exchange;
    readonly dividends: Dividends;
}

export type Dividends = ReadonlyArray<Dividend>;

export interface Dividend {
    readonly exDate: IsoDate;
    readonly value: number;
    readonly yield: number;
    readonly type: DividendType;
    readonly payableDate: IsoDate;
    readonly booksCloseDate: IsoDate | null;
    readonly drpPrice: number | null;
    readonly frankingRate: number;
}

export function orderDividendsByDateAsc(): Comparator<Dividend> {
    return (a, b) => ascending(a.exDate, b.exDate);
}

export function orderDividendsByDateDesc(): Comparator<Dividend> {
    return (a, b) => descending(a.exDate, b.exDate);
}
